import Controller from '../../shared/logic/Controller';
import JobType from '../../shared/model/job/JobType';

export const className = 'JobTypes';
export const dependenciesRunInState = '--NA';
export const fields = {
  list: []
};

export default class JobTypes extends Controller {
  run = async (dependencies, dependenciesForAngular) => {
    const isInRunnableState = await this.init(
      [],
      dependencies,
      dependenciesForAngular,
      dependenciesRunInState
    );
    if (!isInRunnableState) {
      return;
    }
    this.Scope.set(
      {
        isReady: { JobTypes: true }
      },
      true
    );
  };

  constructor(
    $rootScope,
    $scope,
    $state,
    $timeout,
    webpage,
    eventService,
    authenticationService
  ) {
    'ngInject';

    const angularDependencies = [
      $rootScope,
      $scope,
      $state,
      $timeout,
      webpage,
      eventService,
      authenticationService
    ];
    super(angularDependencies, {
      Storage: {
        Table: className
      },
      Scope: {
        Defaults: {
          Name: className
        }
      },
      Data: {
        Model: JobType,
        ModelName: className,
        Requests: {
          available: {
            url: '/api/v1/jobtypes/available/',
            query: {
              fields: JSON.stringify(fields.list),
              orderBy: 'name',
              coerceTo: 'string',
              isDescending: false
            }
          }
        }
      }
    });

    this.run([], angularDependencies);
  }
}
